import { css } from '@emotion/react';
import { scope } from '../../providers/GigerProvider/useTheme.js';
import { SlideInSize } from './types/size.js';

const getWidthBySize = size => size === SlideInSize.REGULAR ? 360 : 528;
const slideInPositionToStyles = {
  top: {
    top: 0,
    left: 0,
    transform: 'translateY(-100%)'
  },
  right: {
    top: 0,
    right: 0,
    transform: 'translateX(100%)'
  },
  bottom: {
    bottom: 0,
    left: 0,
    transform: 'translateY(100%)'
  },
  left: {
    top: 0,
    left: 0,
    transform: 'translateX(-100%)'
  }
};
const openSlideInPositionToStyles = {
  top: {
    transform: 'translateY(0%)'
  },
  right: {
    transform: 'translateX(0%)'
  },
  bottom: {
    transform: 'translateY(0%)'
  },
  left: {
    transform: 'translateX(0%)'
  }
};
const getSlideInSizeStyles = (fullWidthOnMobile, theme, size) => ({
  width: fullWidthOnMobile ? '100vw' : getWidthBySize(size),
  [theme.mediaQuery('tablet')]: {
    width: getWidthBySize(size)
  }
});
const getSlideInStyles = (isOpen, fullWidthOnMobile, position, transitionDuration, size) => scope(theme => {
  return /*#__PURE__*/css({
    position: 'fixed',
    ...slideInPositionToStyles[position],
    transition: `transform ${transitionDuration}ms`,
    ...(isOpen ? openSlideInPositionToStyles[position] : null),
    backgroundColor: theme.palette.white,
    ...(size && getSlideInSizeStyles(fullWidthOnMobile, theme, size))
  }, process.env.NODE_ENV === "production" ? "" : ";label:getSlideInStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});
const getSlideInAsideStyles = elevation => scope(theme => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  ...theme.getElevation(elevation)
}));

export { getSlideInAsideStyles, getSlideInStyles };
//# sourceMappingURL=SlideInStyles.js.map
